import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive } from '@nuxtjs/composition-api'
import AlertLayout from './AlertLayout.vue'
import { ConfirmByThreeButtonConfig } from './types'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmByThreeButton',
  setup(__props, { expose }) {

const isOpen = ref(false)
const config = reactive<ConfirmByThreeButtonConfig>({
  title: '',
  actionTitle: '확인',
  action2Title: '확인2',
  cancelTitle: '취소'
})

const buttonRef = ref(null)

const open = (param: ConfirmByThreeButtonConfig) => {
  config.title = param.title ?? ''
  config.contents = param.contents
  if (param.actionTitle) {
    config.actionTitle = param.actionTitle
  }
  if (param.action2Title) {
    config.action2Title = param.action2Title
  }
  if (param.cancelTitle) {
    config.cancelTitle = param.cancelTitle
  }
  config.action = param.action
  config.action2 = param.action2
  config.cancel = param.cancel

  isOpen.value = true

  const button: any = buttonRef.value
  button && button.$el.focus()
}

const close = () => {
  isOpen.value = false
}

const handleActionClick = () => {
  config.action && config.action()
  close()
}

const handleAction2Click = () => {
  config.action2 && config.action2()
  close()
}

const handleCancelClick = () => {
  config.cancel && config.cancel()
  close()
}

expose({ open, close })

return { __sfc: true,isOpen, config, buttonRef, open, close, handleActionClick, handleAction2Click, handleCancelClick, AlertLayout }
}

})